import { FC, ReactElement } from 'react'

import { ConnectedExchangeShift } from '@/connectors'

export const ExchangeShiftPage: FC = (): ReactElement => <ConnectedExchangeShift />
